module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsIAAA7CARUoSoAAAABsSURBVFhHY/z//z/DQAImKD1gYNQBow4YdcCoA0YdgLcu+FltKgWkbCA8isAR9tbTz6BsFIDXAb+mxl75/+yGNpRLNmCUUHnMlrtcDspFAaNpYNQBow4Y3OUAPcBoGhh1wKgDRh0w0h3AwAAABqYhLePD1rEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/content/CollapseIcon.png
// module id = 657
// module chunks = 0